import { AnnualBalanceCard } from "@/components/pto-balance/AnnualBalanceCard";
import { OtherLeaveSummary } from "@/components/pto-balance/OtherLeaveSummary";
import { QuarterlyBalanceCard } from "@/components/pto-balance/QuarterlyBalanceCard";
import { ErrorState } from "@/components/shared/error-state";
import { Card, CardContent } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import { usePtoBalance } from "@/hooks/use-pto-balance";

// Owns the single usePtoBalance() call + its loading/error states so the
// three balance components below stay presentational — same split as
// AllowancePeriodCard's own loading/error handling.
export function PtoBalanceSection() {
  const { data: balance, isLoading, isError, error, refetch } = usePtoBalance();

  if (isLoading) {
    return (
      <div className="space-y-4">
        <Card>
          <CardContent className="py-6">
            <Skeleton className="h-20 w-full" />
          </CardContent>
        </Card>
        <Card>
          <CardContent className="py-6">
            <Skeleton className="h-24 w-full" />
          </CardContent>
        </Card>
      </div>
    );
  }

  if (isError || !balance) {
    return (
      <Card>
        <CardContent className="py-6">
          <ErrorState
            message={error?.message ?? "Failed to load PTO balance"}
            onRetry={() => refetch()}
          />
        </CardContent>
      </Card>
    );
  }

  return (
    <div className="space-y-4">
      <QuarterlyBalanceCard quarter={balance.quarter} />
      <AnnualBalanceCard annual={balance.annual} />
      <OtherLeaveSummary otherLeave={balance.otherLeave} />
    </div>
  );
}
